export const MESSAGE_AVATAR_OFFSET_PX = 48;
export const MESSAGE_MIN_WIDTH_PX = 284;